import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from './hooks/useAuth';
import { I18nContext, getStrings } from './i18n';
import { api } from './api/client';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { ProjectView } from './pages/ProjectView';
import { RequestAccess } from './pages/RequestAccess';
import { AdminClients } from './pages/admin/Clients';
import { AdminProjects } from './pages/admin/Projects';
import { AdminFileManager } from './pages/admin/FileManager';
import { AdminLeads } from './pages/admin/Leads';
import { Campaigns } from './pages/admin/Campaigns';
import { CampaignDetail } from './pages/admin/CampaignDetail';
import { Profile } from './pages/settings/Profile';
import { SurveyLanding } from './pages/survey/SurveyLanding';
export function App() {
    const [auth, setAuth] = useState({
        user: null, organisation: null, needsAccess: false, diagnosticLead: null, loading: true,
    });
    useEffect(() => {
        api.auth.me()
            .then((data) => setAuth({ ...data, loading: false }))
            .catch((err) => {
            console.error('[auth/me] failed:', err);
            setAuth((prev) => ({ ...prev, needsAccess: true, loading: false }));
        });
    }, []);
    const lang = auth.user?.language ?? 'en';
    const t = getStrings(lang);
    // Public survey route — bypass auth entirely for anonymous respondents
    if (window.location.pathname.startsWith('/survey/')) {
        return (_jsx(BrowserRouter, { children: _jsx(Routes, { children: _jsx(Route, { path: "/survey/:campaignId", element: _jsx(SurveyLanding, {}) }) }) }));
    }
    if (auth.loading) {
        return (_jsx("div", { className: "min-h-screen bg-quintant-black flex items-center justify-center", children: _jsx("p", { className: "text-stone-gray font-mono text-sm", children: t.common.loading }) }));
    }
    if (auth.needsAccess && !auth.user) {
        return (_jsx(I18nContext.Provider, { value: { t, lang }, children: _jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/invite/:code", element: _jsx("div", { children: "TODO: Accept invite page" }) }), _jsx(Route, { path: "*", element: _jsx(RequestAccess, {}) })] }) }) }));
    }
    return (_jsx(AuthContext.Provider, { value: auth, children: _jsx(I18nContext.Provider, { value: { t, lang }, children: _jsx(BrowserRouter, { children: _jsx(Routes, { children: _jsxs(Route, { element: _jsx(Layout, {}), children: [_jsx(Route, { index: true, element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "projects/:id", element: _jsx(ProjectView, {}) }), _jsx(Route, { path: "settings", element: _jsx(Profile, {}) }), auth.user?.role === 'admin' && (_jsxs(_Fragment, { children: [_jsx(Route, { path: "admin/clients", element: _jsx(AdminClients, {}) }), _jsx(Route, { path: "admin/clients/:orgId/projects", element: _jsx(AdminProjects, {}) }), _jsx(Route, { path: "admin/clients/:orgId/projects/:projectId/files", element: _jsx(AdminFileManager, {}) }), _jsx(Route, { path: "admin/leads", element: _jsx(AdminLeads, {}) }), _jsx(Route, { path: "admin/campaigns", element: _jsx(Campaigns, {}) }), _jsx(Route, { path: "admin/campaigns/:id", element: _jsx(CampaignDetail, {}) })] })), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }) }) }) }) }));
}
